import vaultOperationsComponent from './vault_operations.component';

let vaultOperationsModule = angular.module('vaultOperations', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/vault-operations');

        $stateProvider
            .state('vaultOperations', {
                url: '/vault-operations',
                component: 'vaultOperations',
                data: {
                    requireLogin: true,
                    requireACL: 'vault_operations.all'
                },
                parent: 'app',
            })
    })

    .component('vaultOperations', vaultOperationsComponent)

    .name;

export default vaultOperationsModule;    


// WEBPACK FOOTER //
// ./client/app/components/vault_operations/index.js